<template>
  <template v-if="isMobile">
    <button class="el-form-item__label__info" @click="infoClickHandler">
      <IconCircleInfo aria-label="Info anzeigen" color="#737380" size="20" />
    </button>
    <el-dialog v-model="showInfo" :show-close="false" :lock-scroll="isMobile ? true : false">
      <VehicleInfoContent :type="type" @closeInfo="closeInfo" />
    </el-dialog>
  </template>
  <template v-else>
    <el-popover
      trigger="click"
      placement="bottom-end"
      width="fit-content"
      :tabindex="0"
      :teleported="false"
      :visible="showInfo"
    >
      <template #reference>
        <button class="el-form-item__label__info" @click="infoClickHandler">
          <IconCircleInfo aria-label="Info anzeigen" color="#737380" size="20" />
        </button>
      </template>
      <VehicleInfoContent :type="type" />
    </el-popover>
  </template>
</template>

<script>
import VehicleInfoContent from '@/components/Booking/VehicleInfoContent.vue'
import IconCircleInfo from '@/components/icons/IconCircleInfo.vue'
import { mapGetters } from 'vuex'

export default {
  components: { IconCircleInfo, VehicleInfoContent },
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showInfo: false,
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown)
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeydown)
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  methods: {
    toggleInfo() {
      this.showInfo = !this.showInfo
    },
    closeInfo() {
      this.showInfo = false
    },
    infoClickHandler(e) {
      e.preventDefault()
      e.stopPropagation()
      this.toggleInfo()
    },
    handleKeydown(event) {
      if (event.key === 'Escape' && this.showInfo) {
        this.closeInfo()
      }
    },
  },
}
</script>
